import { h, render, Fragment } from 'preact';
import Accordion from '../utils/accordion';
import Image from '../utils/image';
import { useWindowSize } from '../utils/window-size';

export default (element, data) => {
  const init = () => {
    render(<FaqSection />, element);
  };

  const FaqSection = () => {
    const { isMobile } = useWindowSize();

    const renderAccordions = () =>
      data.accordion_blocks.map((accordion) => (
        <Accordion
          className="border-b border-black-30"
          key={accordion.id}
          title={accordion.title}
          content={accordion.overview}
          isGeneric={false}
          classes={{
            accordion: 'py-[19.5px] border-black-30  border-t',
            title:
              'w-[calc(100%-25px)] subheading-base leading-5 text-4 text-black opacity-[90%]',
            content:
              'overflow-hidden max-h-[0px] transition-all duration-300 laptop:px-0 font-13',
          }}
        />
      ));

    return (
      <>
        <div className="laptop:flex laptop:pt-10">
          <div className="laptop:w-[50%] laptop:pl-10 laptop:pr-[10px]">
            <div className="relative laptop:pt-[112.3%] pt-[64%]">
              <Image
                classes="w-full h-full object-cover object-center absolute inset-0"
                src={
                  isMobile
                    ? data.image_mob
                    : data.image_desk
                    ? data.image_desk
                    : data.image_mob
                }
              />
            </div>
          </div>
          <div className="laptop:pr-[100px] laptop:pb-10 pb-[25px] laptop:pl-[90px] laptop:w-[50%] pr-[27px] pl-5 flex flex-col justify-center mt-[25px] laptop:mt-0">
            <div
              className="h5 mb-3 laptop:mb-[39px]"
              dangerouslySetInnerHTML={{
                __html: data.title,
              }}
            ></div>
            <div className="border-b border-black-30">{renderAccordions()}</div>
          </div>
        </div>
      </>
    );
  };

  init();
};
